import React, { useState } from 'react';
import howItWorksImage from "./chart2.png";
import step1 from './Picture1.png';
import step2 from './Picture2.png';
import step3 from './Picture3.png';
import step4 from './Picture4.png';
import MainPopup from '../popup-containers/MainPopup';
import Howitworkspopup from './Howitworkspopup';
import PopUpScreenTitle from '../components/PopUpScreenTitle';

const Howitworks = () => {
  const [Popup, setPopup] = useState(false);

  const openPopup = () => setPopup(true);
  const closePopup = () => setPopup(false);

  return (
    <section
      id="howitworks"
      className="bg-[#0D2B36] text-white scroll-mt-16 py-16 px-6 sm:px-8 lg:px-16 flex items-center justify-center"
    >
      <div className="w-full max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-10 text-center">
          How It Works?
        </h2>

        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center justify-items-center">

          <div className="flex hidden lg:flex justify-center md:justify-start">
            <div className="border-2 border-white ml-24 p-6 rounded-xl shadow-lg">
              <img
                src={howItWorksImage}
                alt="How It Works Illustration"
                className="w-full max-w-xl h-[420px] transition duration-300 ease-out hover:scale-110"
              />
            </div>
          </div>

          <div className="block lg:hidden w-full overflow-x-auto">
            <div className="border-2 border-white p-4 rounded-xl shadow-lg inline-block">
              <img
                src={howItWorksImage}
                alt="How It Works - Mobile"
                className="max-w-full h-auto object-contain"
              />
            </div>
          </div>



          {/* Steps */}
          <div className="flex flex-col justify-between space-y-6">
            {[
              {
                img: step1,
                title: 'Request Assessment',
                desc: 'Company registers by sending an email at emailus@ethosflo.com',
              },
              {
                img: step2,
                title: 'Invite Value Chain Partners',
                desc: 'Company invites value chain partners for assessment using the "Invite Your Partners" button on the website.',
              },
              {
                img: step3,
                title: 'Assessment Process',
                desc: 'Partners complete questionnaires with document evidence.',
              },
              {
                img: step4,
                title: 'Report Generation',
                desc: 'Expert verification and comprehensive report delivery.',
              },
            ].map((step, idx) => (
              <div key={idx} className="flex items-center gap-4 min-h-[120px]">
                <img
                  src={step.img}
                  alt={`Step ${idx + 1}`}
                  className="w-14 h-14 flex-shrink-0 transition duration-300 ease-out hover:scale-110"
                />
                <div>
                  <h3 className="text-lg md:text-xl font-semibold mb-1">{step.title}</h3>
                  <p className="text-base leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}

            <p className="text-xl mt-4 leading-relaxed">
              Ethosflo simplifies ESG assessments in 7 steps—from sign-up to report delivery.
              The requesting company enters partner details; Ethosflo handles outreach, onboarding, and support.
            </p>
          </div>
        </div>

        <button
          className="bg-[#0A988B] hover:bg-teal-400 text-white font-semibold py-3 px-6 block mx-auto mt-12 rounded transition duration-300 text-lg"
          onClick={openPopup}
        >
          See Detailed Process
        </button>

        <MainPopup
          popUpOpen={Popup}
          setpopUpOpen={setPopup}
          loginPopups={true}
          widthAdjustment={true}
          bgcolor={true}
        >
          <PopUpScreenTitle
            title="How it works"
            setpopUpOpen={closePopup}
            titleColorstatus={true}
            hederDetails={true}
          />
          <Howitworkspopup />
        </MainPopup>
      </div>
    </section>
  );
};

export default Howitworks;
